import React from 'react';
import useThemeStore from '../../store/themeStore';

const WelcomeSection = ({ shopAdvantages }) => {
  const { branding } = useThemeStore();

  return (
    <div className="bg-white rounded-lg p-4 md:p-6 shadow-sm mb-4 md:mb-6">
      {/* Logo */}
      <div className="flex justify-end pr-4 md:pr-8 pt-2 mb-2">
        <img 
          src="/new_logo.svg" 
          alt={branding.shopName} 
          className="w-32 h-auto md:w-40 lg:w-44 object-contain copy-protect-image"
          draggable="false"
        />
      </div>
      
      <h2 className="text-xl md:text-2xl font-bold mb-3 md:mb-4 text-center">
        Willkommen bei {branding.shopName}
      </h2>
      
      <p className="text-sm md:text-base text-gray-700 mb-2 md:mb-3 leading-relaxed">
        Entdecken Sie unsere handverlesene Auswahl an einzigartigen Produkten für Ihr Zuhause. 
        Von eleganter Dekoration über hochwertigen Schmuck bis hin zu praktischen Accessoires – 
        bei uns finden Sie alles, was Ihr Herz begehrt.
      </p>
      
      <p className="text-sm md:text-base text-gray-700 mb-3 md:mb-4 leading-relaxed">
        Jedes Produkt wird mit Liebe zum Detail ausgewählt und vereint Qualität, Design und Funktionalität. 
        Unsere weitreichenden Stile sollen Ihre Herzen erobern und Ihr Zuhause in eine Wohlfühloase verwandeln.
      </p>
      
      <p className="text-sm md:text-base text-gray-700 leading-relaxed">
        Stöbern Sie durch unsere Kategorien und lassen Sie sich von unserer vielfältigen 
        Produktauswahl inspirieren. Wir freuen uns darauf, Sie mit besonderen Produkten zu begeistern!
      </p>

      {/* Features - Dynamic Shop Advantages */}
      {shopAdvantages.length > 0 && (
        <div className={`grid ${
          shopAdvantages.length === 1 ? 'grid-cols-1' :
          shopAdvantages.length === 2 ? 'grid-cols-2' :
          shopAdvantages.length === 3 ? 'grid-cols-3' :
          'grid-cols-2 sm:grid-cols-4'
        } gap-3 md:gap-4 mt-4 md:mt-6 pt-4 md:pt-6 border-t`}>
          {shopAdvantages.map((advantage, index) => {
            const accentColors = ['accent-rose', 'accent-mint', 'accent-sky', 'accent-yellow'];
            const accent = accentColors[index % 4];
            
            return (
              <div key={advantage.id} className="text-center p-2">
                <div className={`inline-flex items-center justify-center w-12 h-12 rounded-full ${accent} text-2xl mb-1 md:mb-2 transition-all`}>
                  {advantage.icon}
                </div>
                <h4 className="font-semibold text-xs md:text-sm mb-1">{advantage.title}</h4>
                {advantage.description && (
                  <p className="text-xs text-gray-600">{advantage.description}</p>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default WelcomeSection;
